import { first } from 'lodash';

import ArticleItemList from './helpers/ArticleItemList';
import pathToContent from './helpers/path_to_content';
import placeholder_url from '../../../../placeholder';
import { makeT } from '../../../location/locales';

const mapItemFromData = content => {
  if (!content) {
    return null;
  }
  const { metadata } = content;
  const { settings: { details = {} } = {} } = ({} = metadata);
  const t = makeT(Board.build.language);
  return {
    metadata,
    image: details?.image?.file
      ? details.image
      : { file: placeholder_url(370, 185) },
    img: details?.image?.file || placeholder_url(370, 185),
    alt: details?.image?.alt,
    prehead: [
      details?.taxonomies?.primary_category ||
        first(details?.taxonomies?.categories),
    ]
      .filter(x => x)
      .join(' • '),
    heading: details?.information?.title,
    text: details?.information?.description,
    linkText: t('builder.data.read_more'),
    url: pathToContent(content),
    icon: 'newspaper-o',
  };
};

export default ArticleItemList({
  search: {
    name: 'Paroc Articles',
    type: 'Article::Paroc',
    preview: result => ({
      preheading: result.category,
      heading: result.proper_name,
    }),
  },
  list: {
    availableIn: ['www.paroc.com'],
    name: 'Paroc Articles',
    attributeSet: {
      name: 'Article Attributes',
      path: '',
    },
    dataset: 'paroc_articles',
    itemListMap: mapItemFromData,
    cardSetMap: mapItemFromData,
    categoryFeaturesMap: mapItemFromData,
    enableSearch: true,
  },
});
